// Detect mock mode
export const checkIsMockMode = () => {
  if (typeof window === 'undefined') return true
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
  return !supabaseUrl || supabaseUrl.includes('your-supabase-project')
}

// Helper: dynamic dates relative to now
const now = new Date()
const fmt = (d: Date) => d.toISOString()

const yearStart = new Date(now)
yearStart.setMonth(now.getMonth() - 2)

const yearEnd = new Date(now)
yearEnd.setMonth(now.getMonth() + 4)

const sessionStart = new Date(now)
sessionStart.setDate(now.getDate() - 7)  // started 7 days ago

const sessionEnd = new Date(now)
sessionEnd.setDate(now.getDate() + 60)   // ends 60 days from now

// Initial mock data structure
const initialMockData = {
  departments: [
    { id: 1, name: 'คณิตศาสตร์' },
    { id: 2, name: 'วิทยาศาสตร์และเทคโนโลยี' },
    { id: 3, name: 'ภาษาไทย' },
    { id: 4, name: 'ภาษาต่างประเทศ' }
  ],
  classrooms: [
    { id: 1, grade_level: 7, room_number: '1/1' },
    { id: 2, grade_level: 7, room_number: '1/2' },
    { id: 3, grade_level: 8, room_number: '2/1' },
    { id: 4, grade_level: 9, room_number: '3/1' }
  ],
  subjects: [
    { id: 1, code: 'ค21101', name: 'คณิตศาสตร์พื้นฐาน', department_id: 1, max_score_pre: 10, max_score_post: 10 },
    { id: 2, code: 'ว21101', name: 'วิทยาศาสตร์พื้นฐาน', department_id: 2, max_score_pre: 20, max_score_post: 20 },
    { id: 3, code: 'ท21101', name: 'ภาษาไทยพื้นฐาน', department_id: 3, max_score_pre: 15, max_score_post: 15 },
    { id: 4, code: 'อ21101', name: 'ภาษาอังกฤษพื้นฐาน', department_id: 4, max_score_pre: 10, max_score_post: 10 }
  ],
  students: [
    { id: 1, student_id_card: '10001', first_name: 'นายสมชาย', last_name: 'ใจดี', classroom_id: 1, status: 'active' },
    { id: 2, student_id_card: '10002', first_name: 'นางสาวสมศรี', last_name: 'มีสุข', classroom_id: 1, status: 'active' },
    { id: 3, student_id_card: '10003', first_name: 'นายวิทยา', last_name: 'เก่งกล้า', classroom_id: 1, status: 'active' },
    { id: 4, student_id_card: '10004', first_name: 'นางสาววารุณี', last_name: 'เรียนเก่ง', classroom_id: 2, status: 'active' },
    { id: 5, student_id_card: '10005', first_name: 'นายปกรณ์', last_name: 'รักเรียน', classroom_id: 2, status: 'active' },
    { id: 6, student_id_card: '20001', first_name: 'นายธนา', last_name: 'ปรีชาชาญ', classroom_id: 3, status: 'active' },
    { id: 7, student_id_card: '20002', first_name: 'นางสาวธิดา', last_name: 'รักษ์ไทย', classroom_id: 3, status: 'active' }
  ],
  academicYears: [
    { id: 1, year: 2569, semester: 1, is_active: true, start_date: fmt(yearStart), end_date: fmt(yearEnd) }
  ],
  assessmentSessions: [
    { id: 1, academic_year_id: 1, name: '📝 ก่อนเรียน (Pre-Test)', start_date: fmt(sessionStart), end_date: fmt(sessionEnd), is_open: true }
  ],
  profiles: [
    { id: 'admin-uuid', email: 'admin@demo.com', username: 'admin', first_name: 'สมศักดิ์', last_name: 'แอดมินระบบ', role: 'admin', department_id: null, status: 'approved' },
    { id: 'hod-uuid', email: 'hod@demo.com', username: 'hod', first_name: 'วีระเดช', last_name: 'ยอดคำนวณ', role: 'head_of_department', department_id: 1, status: 'approved' },
    { id: 'teacher-uuid', email: 'teacher@demo.com', username: 'teacher', first_name: 'พัชรี', last_name: 'อักษรดี', role: 'teacher', department_id: 1, status: 'approved' }
  ],
  unlockRequests: [] as any[],
  teachingAssignments: [
    { id: 1, teacher_id: 'teacher-uuid', subject_id: 1, classroom_id: 1, academic_year_id: 1 },
    { id: 2, teacher_id: 'teacher-uuid', subject_id: 1, classroom_id: 2, academic_year_id: 1 },
    { id: 3, teacher_id: 'hod-uuid', subject_id: 1, classroom_id: 3, academic_year_id: 1 }
  ],
  scoreSubmissions: [
    { id: 1, teaching_assignment_id: 1, assessment_session_id: 1, pre_test_status: 'draft', post_test_status: 'draft', pre_test_submitted_at: null, post_test_submitted_at: null },
    { id: 2, teaching_assignment_id: 2, assessment_session_id: 1, pre_test_status: 'draft', post_test_status: 'draft', pre_test_submitted_at: null, post_test_submitted_at: null },
    { id: 3, teaching_assignment_id: 3, assessment_session_id: 1, pre_test_status: 'draft', post_test_status: 'draft', pre_test_submitted_at: null, post_test_submitted_at: null }
  ],
  scores: [
    // Pre-test scores (already graded)
    { id: 1, student_id: 1, subject_id: 1, academic_year_id: 1, assessment_session_id: 1, pre_test_score: 7, post_test_score: null, updated_by: 'teacher-uuid' },
    { id: 2, student_id: 2, subject_id: 1, academic_year_id: 1, assessment_session_id: 1, pre_test_score: 5, post_test_score: null, updated_by: 'teacher-uuid' },
    { id: 3, student_id: 3, subject_id: 1, academic_year_id: 1, assessment_session_id: 1, pre_test_score: 8, post_test_score: null, updated_by: 'teacher-uuid' }
  ],
  examFiles: [] as any[],
  auditLogs: [] as any[]
}

// Get Data helper
export const getMockData = () => {
  if (typeof window === 'undefined') return initialMockData

  const data = localStorage.getItem('tesscore_mock_data')
  if (!data) {
    localStorage.setItem('tesscore_mock_data', JSON.stringify(initialMockData))
    return initialMockData
  }

  try {
    const parsed = JSON.parse(data)

    // Auto-fix: if all sessions are expired or closed, reset sessions from initialMockData
    const now2 = new Date()
    const hasOpenValidSession = (parsed.assessmentSessions || []).some(
      (s: any) => s.is_open && new Date(s.end_date) > now2
    )
    if (!hasOpenValidSession) {
      parsed.assessmentSessions = initialMockData.assessmentSessions
      localStorage.setItem('tesscore_mock_data', JSON.stringify(parsed))
    }

    const merged = { ...initialMockData } as any
    Object.keys(initialMockData).forEach((key) => {
      if (parsed[key] !== undefined && parsed[key] !== null) {
        merged[key] = parsed[key]
      }
    })
    return merged
  } catch (e) {
    localStorage.setItem('tesscore_mock_data', JSON.stringify(initialMockData))
    return initialMockData
  }
}

// Save Data helper
export const saveMockData = (data: any) => {
  if (typeof window === 'undefined') return
  localStorage.setItem('tesscore_mock_data', JSON.stringify(data))
}

// Hard reset all mock data (used for debugging/dev)
export const resetMockData = () => {
  if (typeof window === 'undefined') return
  localStorage.removeItem('tesscore_mock_data')
}
